import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getSearchFaceURL, newSdGroupApiBaseURL, getSearchResultsURL, suggestionAPI, getSearchSuggestionURL,getRealSearchSuggestionURL
} from '../constants/index'


const initialState = {
    searchData: {
        searchResults: [],
        isLoading: false,
        error: null,
        total: 0,
    },
    productCarousel: {
        products: [],
        isLoading: false,
        error: null,
    },
    filterResult: {
        filters: [],
        isLoading: false,
        error: null,
    },
    suggestion: {
        product: [],
        category: [],
        explore: [],
        support: [],
        suggestion: [],
        isLoading: false,
        nodata: false,
        noSuggestiondata: false
    }
};

export const getSearchResults = createAsyncThunk('searchLandingSlice/getSearchResults', async (query) => {
    try {
        return await axios.get(getSearchResultsURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getFacetResults = createAsyncThunk('searchLandingSlice/getFacetResults', async (query) => {
    try {
        return await axios.get(newSdGroupApiBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getProducts = createAsyncThunk('searchLandingSlice/getProducts', async (query) => {
    try {
        return await axios.get(getSearchResultsURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getSuggestion = createAsyncThunk('searchLandingSlice/getSuggestion', async (query) => {
    try {
        return await axios.get(getSearchSuggestionURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getRealSuggestion = createAsyncThunk('searchLandingSlice/getRealSuggestion', async (query) => {
    try {
        return await axios.get(getRealSearchSuggestionURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

export const getFilters = createAsyncThunk('searchLandingSlice/getFilters', async (query) => {
    try {
        return await axios.get(getSearchFaceURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const searchLandingSlice = createSlice({
    name: 'searchLandingSlice',
    initialState,
    reducers: {
        resetAlerts: (state) => {
            state.search.error = '';
            state.search.isLoading = false;
            state.productCarousel.error = '';
            state.productCarousel.isLoading = false;
            state.filterResult.error = '';
            state.filterResult.isLoading = false;
            state.filterResult.nodata = false
            state.filterResult.noSuggestiondata = false
        },
        resetFacet: (state) => {
            state.filterResult = {};
        },
        resetSearchPage: (state) => {
            state.searchData = {
                searchResults: [],
                isLoading: false,
                error: null,
                total: 0
            };
        },
        resetProductList: (state) => {
            state.productCarousel = {
                products: [],
                isLoading: false,
                error: null,
            };
        },
        resetSuggestion: (state) => {
            state.suggestion.product = []
            state.suggestion.category = []
            state.suggestion.explore = []
            state.suggestion.support = []
            state.suggestion.suggestion = []
            state.suggestion.isLoading = false
            state.suggestion.nodata = false
            state.suggestion.noSuggestiondata = false
        }

    },
    extraReducers: (builder) => {

        builder
            .addCase(getSuggestion.pending, (state) => {
                state.suggestion.isLoading = true;
            })
            .addCase(getSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                let data = action?.payload
                if (!data?.grouped?.grpDocumentType?.groups) {
                    state.suggestion.nodata = true
                }
                else {
                    const allResults = data.grouped.grpDocumentType.groups;
                    const products = [];
                    const explore = [];
                    const categoriesArray = [];
                    const support = [];

                    let supportFound = 0, exploreFound = 0;

                    allResults.forEach(group => {
                        if (group.groupValue === "Products") {
                            products.push(...group.doclist.docs.slice(0, 4));
                        }

                        if (['Media Kits', 'Blogs', 'Press Release', 'Solutions', 'Legal', 'Business', 'Company', 'Topics', 'Events', 'Promo', 'Other'].includes(group.groupValue)) {
                            explore.push(...group.doclist.docs);
                            exploreFound += group.doclist.numFound;
                        }

                        if (['Support Products', 'Software Downloads', 'Knowledge Base', 'Documents', 'Community'].includes(group.groupValue)) {
                            support.push(group.doclist.docs[0]);
                            supportFound += group.doclist.numFound;
                        }
                    });

                    products.forEach(prod => {
                        if (prod.productCategoryPagePath_s && prod.productCategoryTitle_s) {
                            categoriesArray.push({ url: prod.productCategoryPagePath_s, title: prod.productCategoryTitle_s });
                        }
                        if (prod.breadcrumbSubCategoryPagePath_s && prod.breadcrumbSubCategoryTitle_s) {
                            categoriesArray.push({ url: prod.breadcrumbSubCategoryPagePath_s, title: prod.breadcrumbSubCategoryTitle_s });
                        }
                    });

                    const uniqueCategories = Array.from(new Set(categoriesArray.map(JSON.stringify))).map(JSON.parse);

                    explore.sort((a, b) => b.score - a.score);

                    state.suggestion.product=products
                    state.suggestion.category= uniqueCategories.slice(0, 5)
                    state.suggestion.support=support
                    state.suggestion.explore=explore.slice(0, 5)

                }
                
                state.suggestion.isLoading = false;
            })
            .addCase(getSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.suggestion.isLoading = false;
                if (state.search) {
                    state.search.error = action.error.message;
                }

            })
            .addCase(getRealSuggestion.pending, (state) => {
                state.suggestion.isLoading = true;
            })
            .addCase(getRealSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                let data = action?.payload
                if (data?.suggest?.shopSuggester ) {
                    state.suggestion.suggestion =Object.values(data.suggest.shopSuggester)[0]?.suggestions.slice(0, 5)
                }
                else {
                    state.suggestion.noSuggestiondata = true
                }
                state.suggestion.isLoading = false;
            })
            .addCase(getRealSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.suggestion.isLoading = false;
                if (state.search) {
                    state.search.error = action.error.message;
                }
                //state.search.error = action.error.message;
            })
            .addCase(getFilters.pending, (state) => {
                state.filterResult.isLoading = true;
                state.loading = true
            })
            .addCase(getFilters.fulfilled, (state, action) => {
                state.loading = false;
                let data = action?.payload
                let filter_data = data?.facet_counts?.facet_fields?.filterSubDocumentType
                const obj = filter_data.reduce((acc, value, index, arr) => {
                    if (index % 2 === 0 && value !== '') {
                        acc[value] = arr[index + 1]; // Use the next element as value
                    }
                    return acc;
                }, {});
                state.filterResult.filters = obj
                state.filterResult.isLoading = false;
            })
            .addCase(getFilters.rejected, (state, action) => {
                state.loading = false;
                state.filterResult.isLoading = false;
                if (state.search) {
                    state.search.error = action.error.message;
                }
                //state.search.error = action.error.message;
            })
            .addCase(getProducts.pending, (state) => {
                state.productCarousel.isLoading = true;
                state.loading = true
            })
            .addCase(getProducts.fulfilled, (state, action) => {
                let data = action?.payload
                state.productCarousel.products = data?.response?.docs
                state.productCarousel.isLoading = false;
                state.loading = false;
            })
            .addCase(getProducts.rejected, (state, action) => {
                state.loading = false;
                state.productCarousel.isLoading = false;
                if (state.search) {
                    state.search.error = action.error.message;
                }
                //state.search.error = action.error.message;
            })

            .addCase(getSearchResults.pending, (state) => {
                state.loading = true
                // state.productCarousel.isLoading = true;
                state.searchData.isLoading = true;
            })
            .addCase(getSearchResults.fulfilled, (state, action) => {
                let data = action?.payload
                // state.productCarousel.products=data?.response?.docs
                state.searchData.searchResults = [data?.highlighting]
                state.searchData.total = data?.response?.numFound
                // state.productCarousel.isLoading = false;
                state.searchData.isLoading = false;
                state.loading = false;
            })
            .addCase(getSearchResults.rejected, (state, action) => {
                state.loading = false;
                // state.productCarousel.isLoading = false;
                if (state.search) {
                    state.search.error = action.error.message;
                }
                //state.search.error = action.error.message;
            })


    }
})

export const { resetAlerts, resetFacet, resetSearchPage, resetProductList, resetSuggestion } = searchLandingSlice.actions
export default searchLandingSlice.reducer

